// ReduxCashierCartReducer.js

import CreateCartSlice from "../utils/common/CreateCartSlice";

const cashierCartSlice = CreateCartSlice("cashierCart");

export const {
  setUserRefCode: setCashierUserRefCode,
  addItemToCart: addCashierItemToCart,
  removeItemFromCart: removeCashierItemFromCart,
  increaseItemQuantity: increaseCashierItemQuantity,
  decreaseItemQuantity: decreaseCashierItemQuantity,
  updateItemQuantity: updateCashierItemQuantity,
  clearCart: clearCashierCart,
} = cashierCartSlice.actions;

export default cashierCartSlice.reducer;
